<div class="max-w-md mx-auto mt-10 p-6 bg-white rounded-lg shadow">
  <h2 class="text-2xl font-bold mb-4 text-center">Login</h2>
  <form (submit)="onLogin(); $event.preventDefault()">
    <label class="block mb-2">Username</label>
    <input type="text" [(ngModel)]="username" name="username" class="w-full p-2 border rounded mb-4" required />

    <label class="block mb-2">Password</label>
    <input type="password" [(ngModel)]="password" name="password" class="w-full p-2 border rounded mb-4" required />

    <button type="submit" class="w-full bg-blue-600 text-white py-2 rounded">Login</button>

    <p class="text-red-500 mt-2 text-center" *ngIf="error">{{ error }}</p>
  </form>
</div>

